/** Keeps CSR in-call UI alive when the chat modal is minimized or closed. */
let session = null;
const listeners = new Set();

export function getCsrActiveCallSession() {
  return session;
}

export function setCsrActiveCallSession(next) {
  session = next;
  listeners.forEach((fn) => {
    try {
      fn(session);
    } catch {
      // ignore listener errors
    }
  });
}

export function subscribeCsrActiveCallSession(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
